module.exports = __webpack_public_path__ + "img/img_bgmore.8ab680d6.jpg";